/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Taxnote1Inputs */

const ja_playdata_pricing_taxnote1 = /** @type {(inputs: Playdata_Pricing_Taxnote1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`税抜`)
};

const en_playdata_pricing_taxnote1 = /** @type {(inputs: Playdata_Pricing_Taxnote1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excl. tax`)
};

/**
* | output |
* | --- |
* | "excl. tax" |
*
* @param {Playdata_Pricing_Taxnote1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_pricing_taxnote1 = /** @type {((inputs?: Playdata_Pricing_Taxnote1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Taxnote1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_taxnote1(inputs)
	return en_playdata_pricing_taxnote1(inputs)
});
export { playdata_pricing_taxnote1 as "playdata_pricing_taxNote" }